import styled from 'styled-components';
import { colors } from '@oxygen/theme';

export const StyledNoPropertyResults = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${colors.storm1};
  font-size: 15px;
  overflow: hidden;
`;

export const NoPropertiesImageWrapper = styled.div`
  overflow: hidden;
  svg {
    width: 1440px;
    height: 398px;
    left: 50%;
    position: relative;
    transform: translateX(-50%);
  }
`;

export const Title = styled.div`
  text-align: center;
  font-size: 2.5rem;
  padding: 24px 16px;
`;
